import { takeLatest } from "redux-saga/effects";

import { actionTypes } from "../actions";
import { fetchCfarQuotesSaga } from "./fetchCfarQuotesSaga";

export function* watchFetchCfarOffers() {
  yield takeLatest(actionTypes.FETCH_CFAR_QUOTES, fetchCfarQuotesSaga);
}
